/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IServerData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";

export interface ITractorBeamParsedData extends IServerData {
    scatterSymbolWin:number;
    totalBetLineWins:number;
    totalSpinWinnings:number;
    randomFeatureTriggered:boolean;
    removedSymbols:string[];
    numberOfExtraFreespinsAwarded:number;
    scatterExtraSpinPositions:number[];

}

export class TractorBeamServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }

    public scatterSymbolWin(rawData:ITractorBeamParsedData):number {
        return rawData.scatterSymbolWin;
    }

    public totalBetLineWins(rawData:ITractorBeamParsedData):number {
        return rawData.totalBetLineWins;
    }

    public totalSpinWinnings(rawData:ITractorBeamParsedData):number {
        return rawData.totalSpinWinnings;
    }

    public randomFeature(rawData:ITractorBeamParsedData):boolean {
        return rawData.randomFeatureTriggered;
    }

    public removedSymbols(rawData:ITractorBeamParsedData):string[] {
        return rawData.removedSymbols;
    }

    public numberOfExtraFreespinsAwarded(rawData:ITractorBeamParsedData):number {
        return rawData.numberOfExtraFreespinsAwarded;
    }

    public scatterExtraSpinPositions(rawData:ITractorBeamParsedData):number[] {
        return rawData.scatterExtraSpinPositions;
    }
}
